import(/* webpackMode: "eager" */ "/Users/viper/code/sms/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/viper/code/sms/src/components/Cards/NumberCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/viper/code/sms/src/components/Cards/TotalNumbersCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/viper/code/sms/src/components/EsimRoamingSection/EsimRoamingSectionWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/viper/code/sms/src/components/Home/CardsGrid.tsx");
